import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	buttonAction: {
		width: 305.2,
		height: 54,
		fontSize: 15,
		...ColorUtil.getBackgroundAndContrastColor("transparent"),
		color: colors.green[600]
	},
	inputLabelPadding: {
		marginBottom: 16,
		display: "flex",
		alignItems: "center"
	}
}))

export default useStyles
